const Register = () => {
  return (
    <>
      <h2>Register page</h2>
    </>
  );
};

export default Register;
